import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

// ─── NASP TRACKER ─────────────────────────────────────────────────────────────

export const NaspTrackerGetRequest = (userFlag = 'All') => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}NaspTracker/GetNaspTracker`,
	params: { userFlag },
	hasLoading: false,
});

export const NaspTrackerGetByIdRequest = (id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}NaspTracker/GetNaspTrackerById`,
	params: { id },
	hasLoading: false,
});

export const NaspTrackerGetDropdownsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}NaspTracker/GetNaspTrackerDropdowns`,
	hasLoading: false,
});

export const NaspTrackerGetClosedRequest = (userFlag = 'All') => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}NaspTracker/GetNaspTrackerClosed`,
	params: { userFlag },
	hasLoading: false,
});

export const NaspTrackerUpdateRequest = (userId, dto) => AxiosRequest({
	method: 'PUT',
	url: `${config.API_URL}NaspTracker/UpdateNaspTracker`,
	params: { userId },
	data: dto,
	hasLoading: true,
});

export const NaspTrackerAddCommentRequest = (userId, dto) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}NaspTracker/AddNaspTrackerComment`,
	params: { userId },
	data: dto,
	hasLoading: true,
});

export const NaspTrackerExportRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}NaspTracker/ExportNaspTracker`,
	params: { userId },
	hasLoading: false,
});